/**
 * 通用接口
 */
import axios from './axios'
//
export const queryContractTemplateList = (data) => {
  return axios.post('/app/contractTemplate/queryContractTemplateList', data)
}

export const queryAppInfo = (data) => {
  return axios.post('/app/appInfo/queryAppInfo', data)
}

// 博客相关接口
export const queryManageArticlePage = (data) => {
  return axios.post('/manage/article/queryManageArticlePage', data)
}

export const getManageArticleDetail = (data) => {
  return axios.post('/manage/article/getManageArticleDetail', data)
}
